import type { CSSProperties, ReactNode } from 'react'
import type { ShareBasis } from '../types'
import { segmentMarketScope } from '../mainSegmentShare'
import { ACTIVE_SUPPLIER } from '../tenant'
import { InfoTip } from './InfoTip'

// MPD-64 / MP-OS-187 — a share always shows what it is a share of. The denominator and period
// stay visible; the full basis sentence from the server (numerator, unit) and any note go in
// the ⓘ. A denominator narrowed to the supplier's product types says so in the share card's
// wording (MPD-76 F1), and never as "all …" (MPD-84 S5): "all Vape CU" would contradict the ⓘ.
export function ShareBasisLine({ basis, prefix = '', note, label = 'About the share', className, style }: {
  basis: ShareBasis
  prefix?: string
  note?: ReactNode
  label?: string
  className?: string
  style?: CSSProperties
}) {
  const scope = basis.market_scope ? segmentMarketScope(basis.market_scope, ACTIVE_SUPPLIER.label) : null
  const denominator = scope?.narrowed ? basis.denominator.replace(/^all /, '') : basis.denominator
  const text = denominator === basis.denominator ? basis.text : basis.text.replace(`of ${basis.denominator}`, `of ${denominator}`)
  return (
    <p className={className} style={style}>
      {`${prefix}% of ${denominator} · ${basis.period}`}
      <InfoTip label={label} size="small">
        {text}.{scope?.note ?? ''}{note}
      </InfoTip>
    </p>
  )
}
